var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"application-features-title_block"},[_c('div',{staticClass:"max-width-800"},[_c('v-title',{attrs:{"font-size":32,"text":_vm.item.titleText}}),_c('v-button',{attrs:{"text":_vm.item.buttonText}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }